<template>
  <div>
    <h1 class="text-primary">Herzlichen Glückwunsch!</h1>

    <p class="mt-2">
      Ihre Eingaben wurden erfolgreich verarbeitet.
    </p>
    <p>Danke für Ihre Bestellung. Sie erhalten nach der internen Bearbeitung von Cable 4 eine Auftragsbestätigung mit
      allen Kunden- und Auftragsdaten sowie die AGB in Schriftform.</p>

    <p class="mt-1">
      <span class="font-weight-bolder">
        Achtung:
      </span>
      Im Rahmen der gesetzlich vorgeschriebenen bundesweiten Abrechnungsumstellung des TV-Kabelanschlusses kommt es
      aktuell bei allen Fernsehanbietern zu einem immens erhöhten Verwaltungsaufwand – auch bei uns. Dadurch verzögert
      sich eventuell die Erfassung der Kundenaufträge und der Versand der Auftragsbestätigungen. Dafür bitten wir um
      Nachsicht. Wir werden bis zur vollständigen Erfassung und Bestätigung aller Buchungen keinerlei technische
      Abschaltungen vornehmen. Sie können in aller Ruhe weiterhin Ihr gewohntes Kabelfernsehen vollumfänglich nutzen.
      Für Ihre Geduld und Ihr Verständnis bedanken wir uns sehr.
    </p>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "CheckoutFinish",
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA']),
  },
  beforeMount() {
    if (!this.SERVICE || !this.CHECKOUT_DATA) {
      this.$router.push({name: 'Availability'})
    }
  },
}
</script>

<style scoped>

</style>
